import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opens up the edit mode so they can start trimming their video',
  name: 'enter_video_edit_mode',
};

export default META;
